import { defineSemanticTokens } from "@pandacss/dev";
import { semanticColors as colors } from "./colors";
import { semanticSpacing as spacing } from "./spacing";
import { semanticRadii as radii } from "./radii";
import { semanticFontWeights as fontWeights } from "./font";
import { semanticMotion as motion } from "./motion";

/**
 * Semantic tokens
 * Contextual tokens that reference base tokens for specific use cases
 */
export const semanticTokens = defineSemanticTokens({
	colors,
	radii,
	spacing,
	fontWeights,
	motion,
});
